// 吉隆坡球场数据
// Kuala Lumpur Golf Courses

export const KUALA_LUMPUR_COURSES = {
  "BUKIT_JALIL_GOLF_AND_COUNTRY_RESORT": {
    shortName: "BJGCR",
    fullName: "Bukit Jalil Golf & Country Resort",
    location: ["Bukit Jalil", "Kuala Lumpur", "Malaysia"],
    pars: [4,4,5,3,4,4,4,3,5, 4,5,4,3,4,4,3,5,4],
    index: [5,1,7,17,3,13,15,9,11, 10,8,2,14,16,12,18,6,4]
  },

  "KELAB_GOLF_TITIWANGSA_PDRM": {
    shortName: "KGTP",
    fullName: "Kelab Golf Titiwangsa PDRM",
    location: ["Setapak", "Kuala Lumpur", "Malaysia"],
    pars: [3,4,5,3,4,5,4,4,4],
    index: [8,2,5,9,3,1,6,7,4]
  },

  "KELAB_REKREASI_ANGKATAN_TENTERA_KL": {
    shortName: "KRAT-KL",
    fullName: "Kelab Rekreasi Angkatan Tentera (Kuala Lumpur)",
    location: ["Kuala Lumpur", "Kuala Lumpur", "Malaysia"],
    pars: [4,3,4,3,3,5,4,4,3, 4,3,4,3,3,5,4,4,3],
    index: [,,,,,,,,, ,,,,,,,,]
  },

  "KUALA_LUMPUR_GOLF_AND_COUNTRY_CLUB_EAST": {
    shortName: "KLGCC-E",
    fullName: "Kuala Lumpur Golf & Country Club (East Course)",
    location: ["Bukit Kiara", "Kuala Lumpur", "Malaysia"],
    pars: [4,4,4,4,3,5,3,4,4, 4,4,5,4,4,3,5,3,4],
    index: [15,3,7,11,17,1,13,5,9, 12,6,2,8,14,18,16,10,4]
  },

  "KUALA_LUMPUR_GOLF_AND_COUNTRY_CLUB_WEST": {
    shortName: "KLGCC-W",
    fullName: "Kuala Lumpur Golf & Country Club (West Course)",
    location: ["Bukit Kiara", "Kuala Lumpur", "Malaysia"],
    pars: [4,4,5,3,5,4,4,3,4, 5,3,4,4,4,3,4,4,5],
    index: [5,3,1,17,7,11,9,15,13, 4,16,6,2,12,18,8,14,10]
  },

  "ROYAL_SELANGOR_GOLF_CLUB": {
    shortName: "RSGC",
    fullName: "Royal Selangor Golf Club",
    location: ["Kuala Lumpur", "Kuala Lumpur", "Malaysia"],
    pars: [4,4,5,3,5,3,4,4,4, 4,4,3,5,4,5,4,3,4],
    index: [3,7,13,11,17,5,9,15,1, 18,4,10,12,16,6,8,14,2]
  }
};

export default KUALA_LUMPUR_COURSES;
